import gql from 'graphql-tag';

export const YearbookPhotoDetails = gql`
  fragment YearbookPhotoDetails on YearbookPhoto {
    id
    album_folder {
      id
    }
    identity {
      id
    }
    photo {
      id
      thumbnail_urls {
        url
        width
        height
        size_code
      }
    }
    facebox {
      x
      y
      width
      height
    }
    thumbnail_url {
      url
    }
  }
`;

export const MatchedPhotoYearbookPhotoDetails = gql`
  fragment MatchedPhotoYearbookPhotoDetails on MatchedPhoto {
    id
    yearbook_photo {
      ...YearbookPhotoDetails
    }
  }
  ${YearbookPhotoDetails}
`;

export const IdentityYearbookPhotoDetails = gql`
  fragment IdentityYearbookPhotoDetails on Identity {
    id
    yearbook_photo(album_folder_id: $album_folder_id) {
      ...YearbookPhotoDetails
    }
  }
  ${YearbookPhotoDetails}
`;
